export default class Pagination {
	constructor(element) {
		 this.element = element;
		 let pageLinks = this.element.querySelectorAll('.page-numbers');

		 pageLinks.forEach(function(link) {
			  link.addEventListener('click', function(e) {
					e.preventDefault();

					let targetUrl = this.getAttribute('href');
					window.location.href = targetUrl;
			  });
		 });
	}
}
